import approvedListingLocations from './approved-listing-locations.cjs'
// Curated by stable document ID. Titles and ordering can change independently.
export const GUIDE_GROUPS = [
  { id: 'planning', label: 'Plan your trip', ids: ['blog-best-time-visit-selong-belanak', 'blog-getting-to-selong-belanak-transport', 'blog-three-day-selong-belanak-itinerary', 'blog-selong-belanak-family-guide'] },
  { id: 'beaches', label: 'Beaches & activities', ids: ['blog-beginner-surfing-selong-belanak', 'blog-selong-belanak-serangan-mawi-guide', 'blog-selong-belanak-active-wellness-guide'] },
  { id: 'food-stays', label: 'Food & places to stay', ids: ['blog-where-to-stay-selong-belanak-guide', 'blog-selong-belanak-restaurants-guide', 'blog-selong-belanak-cafes-breakfast-healthy-food', 'blog-selong-belanak-nightlife-bars-live-music'] },
]
export const HOME_GUIDE_IDS = ['blog-best-time-visit-selong-belanak', 'blog-getting-to-selong-belanak-transport', 'blog-selong-belanak-family-guide', 'blog-selong-belanak-serangan-mawi-guide', 'blog-three-day-selong-belanak-itinerary']
export const PLANNING_LINKS = [
  { id: 'arrival', label: 'Getting here', text: 'Flights, boats and the onward journey', href: '/getting-to-selong-belanak' },
  { id: 'local-transport', label: 'Getting around', text: 'Plan your local transport', href: '/getting-around' },
  { id: 'season', label: 'When to visit', text: 'Weather, surf and seasonal trade-offs', href: '/blog/best-time-to-visit-selong-belanak' },
  { id: 'stays', label: 'Where to stay', text: 'Compare accommodation by area', href: '/where-to-stay' },
  { id: 'food', label: 'Where to eat', text: 'Restaurants, cafés and local warungs', href: '/eat-drink' },
  { id: 'itinerary', label: 'Three days here', text: 'An itinerary for beaches, food and surf', href: '/blog/three-day-selong-belanak-itinerary' },
]
export function selectGuides(posts, ids) {
  const byId = new Map(posts.map(post => [post._id?.replace(/^drafts\./, ''), post]))
  return ids.map(id => byId.get(id)).filter(Boolean)
}
export function filterListings(listings, { category = '', area = '' } = {}) {
  return listings.filter(item => (!category || item.category === category) && (!area || item.area === area))
}
export function sectionAnchor(section) {
  return section?._key ? `section-${encodeURIComponent(section._key)}` : undefined
}
export function mapEligibleListings(listings) {
  return listings.map(approvedListingLocations.applyApprovedListingLocation).filter(item => item.verified === true && item.latitude != null && item.longitude != null && String(item.latitude).trim() !== '' && String(item.longitude).trim() !== '')
    .map(item => ({ ...item, latitude: Number(item.latitude), longitude: Number(item.longitude) }))
    .filter(item => Number.isFinite(item.latitude) && Number.isFinite(item.longitude) && Math.abs(item.latitude) <= 90 && Math.abs(item.longitude) <= 180)
}
export function plainText(blocks) {
  if (typeof blocks === 'string') return blocks
  return (Array.isArray(blocks) ? blocks : []).map(block => (block.children || []).map(child => child.text || '').join('')).filter(Boolean).join(' ')
}
export function firstSentence(blocks) {
  const text = plainText(blocks)
  return text.match(/^.*?[.!?](?:\s|$)/)?.[0]?.trim() || text
}
